import { useLang } from '../i18n/LangContext';
import * as EN from './content';
import * as FR from './content.fr';

export function useContent() {
  const { isFr } = useLang();
  if (!isFr) return EN;

  return {
    ...EN,
    SERVICES: FR.SERVICES,
    TILES: EN.TILES.map((t) => ({ ...t, label: FR.TILES_LABELS[t.slug] || t.label })),
    GALLERY_EXTRA: EN.GALLERY_EXTRA.map((g) => ({ ...g, label: FR.GALLERY_EXTRA_LABELS[g.label] || g.label })),
    PROMISES: FR.PROMISES,
    STEPS: FR.STEPS,
    TEAM: EN.TEAM.map((m) => ({ ...m, ...(FR.TEAM_ROLES[m.name] || {}) })),
    COMPARISON: FR.COMPARISON,
    REVIEWS: FR.REVIEWS,
    TICKER: FR.TICKER,
    HOME_FAQS: FR.HOME_FAQS,
    AREAS: EN.AREAS.map((a) => ({ ...a, ...(FR.AREAS_COPY[a.slug] || {}) })),
    BLOG_POSTS: FR.BLOG_POSTS,
    BEFORE_AFTER: FR.BEFORE_AFTER,
  };
}
